import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { BasicInfoService } from "../../services/basicinfo/basicinfo.service";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { FormBankAccountToEdit } from "../forms/formBankAccountToEdit";
import { sanitizarInputNumerico } from "../../utils/validateData";

export function EditBankAccountDialog({
    dialogOpen,
    setDialogOpen,
    _state,
    setState,
    refreshAccounts,
    accountToEdit,
    handleOpenAlert
}) {
    const [open, setOpen] = useState(dialogOpen);
    const [errorField, setErrorField] = useState({});
    const [disableBtn, setDisableBtn] = useState(false);

    const cancelButtonRef = useRef(null);

    const clearStateBankAccount = () => {
        setState({
            bankAccount: "",
            typeBankAccount: "",
            accountNumber: "",
            parent: false,
        });
    };

    const handleOpenSnackbar = (type, message, isOpen) => {
        handleOpenAlert(type, message, isOpen);
    }

    const handleToggleDialog = () => {
        if (dialogOpen) {
            setDialogOpen(false);
        } else {
            setDialogOpen(true);
        }
        setErrorField({});
        clearStateBankAccount();
    };

    const validateData = () => {
        const newErrors = {};
        let hasValidate = true;
        if (
            _state.typeBankAccount === "Seleccione una opción." ||
            _state.typeBankAccount === ""
        ) {
            newErrors.typeBankAccount = "Debe seleccionar una opción válida.";
        } else if (_state.accountNumber.length === 0) {
            newErrors.accountNumber = "Ingrese un numero de cuenta válido.";
        } else if (
            _state.bankAccount === "Seleccione una opción." ||
            _state.bankAccount === ""
        ) {
            newErrors.bankAccount = "Debe seleccionar una opción válida.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrorField(newErrors);
            hasValidate = false;
        } else {
            setErrorField({});
        }
        return hasValidate;
    };

    const handlesubmit = async () => {
        try {
            setDisableBtn(true);
            let __error;
            let __message;
            let hasValidate = validateData();
            if (!hasValidate) return;
            _state.accountNumber = sanitizarInputNumerico(_state?.accountNumber);

            let { error, message } = await BasicInfoService.updateBankAccount(localStorage.getItem("doc"), { bankAccount: _state });
            __error = error;
            __message = message;

            if (__error) {
                return handleOpenSnackbar(
                    "error",
                    __message?.message ||
                    "Ha ocurrido un error inesperado, por favor intenta más tarde.",
                    true
                );
            }
            handleOpenSnackbar(
                "success",
                "¡Hemos actualizado tu cuenta bancaria con éxito!.",
                true
            );
            await refreshAccounts();

            if (dialogOpen) {
                setDialogOpen(false);
            } else {
                setDialogOpen(true);
            }
            clearStateBankAccount();
            return;
        } catch (error) {
            console.log(error?.message);
        } finally {
            setDisableBtn(false);
        }
    };

    return (
        <>
            <Transition.Root show={open} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-50"
                    initialFocus={cancelButtonRef}
                    onClose={handleToggleDialog}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-tdark bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="text-tdark font-walsheim tracking-tight relative transform overflow-auto rounded-lg bg-white text-left shadow-xl transition-all my-8 max-w-sm p-6">
                                    <div>
                                        <div className="">
                                            <div className="flex justify-end w-full">
                                                <XMarkIcon
                                                    className="w-6 h-auto text-md flex justify-center border border-transparent rounded-full font-semibold text-tdark bg-purpleLight transition duration-300 focus:outline-none cursor-pointer"
                                                    onClick={handleToggleDialog}
                                                />
                                            </div>
                                            <div className="text-center mt-3 sm:mt-5">
                                                <Dialog.Title as="h1" className="text-xl font-semibold">
                                                    Actualizar cuenta bancaria
                                                </Dialog.Title>
                                                <div className="mt-2">
                                                    <p className="text-sm text-auto">
                                                        La cuenta bancaria que edites la puedes
                                                        seleccionar para que te llegue el dinero a partir
                                                        del próximo crédito.
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="mt-2">
                                                <FormBankAccountToEdit
                                                    _state={_state}
                                                    setState={setState}
                                                    errorField={errorField}
                                                    accountToEdit={accountToEdit}
                                                ></FormBankAccountToEdit>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex mt-2 pt-6">
                                        <div className="flex gap-2 w-full">
                                            <div className="w-full">
                                                <button
                                                    disabled={disableBtn}
                                                    className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-md font-semibold text-white ${disableBtn ? "bg-grayP opacity-70" : "bg-purple hover:bg-purpleDark"} transition duration-300  focus:outline-none`}
                                                    onClick={handlesubmit}
                                                >
                                                    Actualizar cuenta
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
}
